var exports = {
  "iE": "x234b8571--054968--wrapper",
  "o0": "x234b8571--054968--slider-wrapper",
  "jB": "x234b8571--054968--promos",
  "Xk": "x234b8571--054968--all-promos",
};

module.exports = exports;
